<template>
  <div :class="['usage-details', closing ? 'closing' : 'opening']" :style="style">

    <div class="details" v-if="!editing">
      <div class="top">
        <div class="date-time">
          <span class="day">{{new Date(usage.fromTimestamp).toLocaleDateString('nl-NL')}}</span>
          {{new Date(usage.fromTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}} -
          {{new Date(usage.toTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}}
        </div>
        <div class="close" @click="close()">
          <span>X</span>
        </div>
      </div>
      <div class="bottom">
        <p v-if="usage.correlation">Dit is een wekelijks terugkerend gebruiksmoment.</p>
        <div v-if="usage.userId === userId">
          <br>
          <button @click="editing = true">Gebruiksmoment aanpassen</button>
          <br>
          <button @click="deleteUsage">Verwijder gebruiksmoment</button>
          <br>
          <button v-if="usage.correlation" @click="deleteUsageCorrelated">Verwijder alle gebruiksmomenten in deze reeks</button>
        </div>
        <p v-else>Een gebruiksmoment van een ander mag je niet aanpassen of verwijderen. Vraag <span class="name">{{usage.userName}}</span> om het gebruiksmoment te veranderen.</p>
      </div>
    </div>

    <div class="details" v-else-if="usage.userId === userId">
      <div class="top">
        <div class="date-time">
          <div class="day">Aanpassen</div>
        </div>
        <div class="close" @click="close()">
          <span>X</span>
        </div>
      </div>
      <div class="bottom">
        <p>Vul het nieuwe start- en eindmoment in.</p>
        <input :disabled="isUpdating" @change="changeFromTimestamp" :value="usage.fromTimestamp" type="datetime-local">
        <br><br>
        <input :disabled="isUpdating" @change="changeToTimestamp" :value="usage.toTimestamp" type="datetime-local">
        <br><br>
        <div class="save">
          <button :disabled="isUpdating" @click="save">Opslaan</button>
          <button :disabled="isUpdating" @click="editing = false">Terug</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'

export default {
  name: 'UsageDetails',
  props: {
    usage: {
      type: Object
    }
  },
  data() {
    return {
      editing: false,
      newFromTimestamp: null,
      newToTimestamp: null,
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      isUpdating: false,
      closing: false
    }
  },
  methods: {
    deleteUsageCorrelated() {
      const confirmationMessage = 'Weet je zeker dat je deze, en alle andere, terugkerende gebruiksmomenten wilt verwijderen?';

      if (confirm(confirmationMessage)){
        const token = localStorage.getItem('token');
        this.isUpdating = true;

        this.axios.delete(this.config.api + '/usages/' + this.usage.id + '/correlated', {
          headers: {
            authorization: token
          }
        })
          .then(() => {
            this.$emit('deletedRecurring', this.usage.id)
            this.close();
            this.isUpdating = false;
          })
          .catch((error) => {
            this.isUpdating = false;
            alert(error.message)
          })
      }
    },
    deleteUsage() {
      const confirmationMessage = 'Weet je zeker dat je dit gebruiksmoment wilt verwijderen?';

      if (confirm(confirmationMessage)){
        const token = localStorage.getItem('token');
        this.isUpdating = true;

        this.axios.delete(this.config.api + '/usages/' + this.usage.id, {
          headers: {
            authorization: token
          }
        })
          .then(() => {
            this.$emit('deleted', this.usage.id)
            this.close();
            this.isUpdating = false;
          })
          .catch((error) => {
            this.isUpdating = false;
            alert(error.message)
          })
      }
    },
    changeFromTimestamp(e) {
      const { value } = e.target;

      this.newFromTimestamp = new Date(value).getTime();
    },
    changeToTimestamp(e) {
      const { value } = e.target;

      this.newToTimestamp = new Date(value).getTime();
    },
    save() {
      if (!this.newFromTimestamp || !this.newToTimestamp) {
        alert('Kies een nieuw start- en eindmoment')
        return;
      }

      if (new Date(this.newToTimestamp).toLocaleDateString() !== new Date(this.newFromTimestamp).toLocaleDateString()) {
        alert('Het start- en eindmoment moeten op dezelfde dag vallen.');
        return;
      }

      const token = localStorage.getItem('token');
      this.isUpdating = true;

      this.axios.put(this.config.api + '/usages', {
        id: this.usage.id,
        userId: this.usage.userId,
        fromTimestamp: this.newFromTimestamp,
        toTimestamp: this.newToTimestamp
      }, {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.isUpdating = false;
          this.close();
          this.$emit('update', result.data.message)
        })
        .catch(error => {
          this.isUpdating = false;
        })
    },
    close() {
      this.closing = true;

      setTimeout(() => {
        this.$emit('close');
      }, 500)
    }
  },
  computed: {
    style: function() {
      return `background-color:${this.usage.userColour}`
    }
  }
}
</script>

<style scoped>

.save {
  display: flex;
  justify-content: space-evenly;
}

.closing {
  animation: close .5s 1;
}

.opening {
  animation: fadein 1s 1;
}

@keyframes close {
  0% {
    top: 0;
    opacity: 1;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}

.day {
  display: block;
  font-size: 20px;
}

.name {
  text-decoration: underline;
}

.close {
  background-color: rgba(0, 0, 0, 0.514);
  color: white;

  border-radius: 50%;
  width: 50px;
  height: 50px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  transition: .2s;
}

.close:active {
  background-color: black;

  transition: .2s;
}

.top {
  display: flex;
  justify-content: space-between;
}

.usage-details {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  padding: 10px;

  user-select: none;

  color: black;

  z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/UsageDetails.vue